<mat-card>
  <mat-card-header class="full-width-header">
    <mat-card-title>
      <div class="title-row">
        <span>{{ 'AI_ASSISTANT.SETTINGS.CAPABILITIES' | translate }}</span>
        @if (capabilities().dirty) {
          <span class="unsaved-changes-text">
            {{ 'AI_ASSISTANT.SHARED.UNSAVED_CHANGES.TITLE' | translate }}
          </span>
        }
      </div>
    </mat-card-title>
    <mat-card-subtitle>{{ 'AI_ASSISTANT.SETTINGS.CAPABILITIES_DESCRIPTION' | translate }} </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    @if (visibleCapabilityIndices().length === 0) {
      <div class="empty-state-inline">
        <mat-icon>auto_awesome</mat-icon>
        <span>{{ 'AI_ASSISTANT.SETTINGS.EMPTY_STATE.NO_CAPABILITIES' | translate }}</span>
      </div>
    } @else {
      <div class="capabilities-grid">
        @for (capabilityItem of capabilityItems(); track capabilityItem.capability; let i = $index) {
          @let capability = capabilityItem.capability;
          @if (!capability.isHidden) {
            <mat-card
              class="capability-card"
              [class.clickable-card]="capabilityClickable(capability)"
              (click)="capabilityClickable(capability) ? handleCapabilityClicked(capability, $event) : null"
              [class.invalid-form]="capability.invalid"
            >
              <mat-card-content>
                <div class="capability-header">
                  <div class="capability-info">
                    <div class="capability-title">
                      <div class="capability-title-left">
                        {{ capability.controls.name.value }}
                        @if (capability.isOverride()) {
                          <glxy-badge [color]="'blue'" size="small" class="custom-badge">
                            {{ 'AI_ASSISTANT.SHARED.MODIFIED' | translate }}
                          </glxy-badge>
                        }
                      </div>
                      @if (capability.dirty) {
                        <span class="unsaved-changes-text">
                          {{ 'AI_ASSISTANT.SHARED.UNSAVED_CHANGES.TITLE' | translate }}
                        </span>
                      }
                    </div>
                    <div [class]="'capability-description' + (hasCustomForm(capability) ? ' custom-form-padding' : '')">
                      {{ capability.controls.description.value }}
                      @if (
                        capability.controls.goalId.value && learnMoreComponents.has(capability.controls.goalId.value)
                      ) {
                        <a
                          class="learn-more-link"
                          (click)="handleLearnMoreClicked(capability.controls.goalId.value, $event)"
                          >{{ 'AI_ASSISTANT.SETTINGS.LEARN_MORE' | translate }}</a
                        >
                      }
                    </div>
                    @if (hasCustomForm(capability)) {
                      <ai-capability-form-loader
                        [capabilityForm]="capability"
                        [onlySpecialCaseCapabilities]="true"
                        [assistantType]="assistant()?.assistant?.type"
                        (toolFormDisplay)="
                          toolFormDisplay.emit(
                            $event !== undefined
                              ? { form: $event.form, parentCapabilityForm: $event.parentCapabilityForm }
                              : undefined
                          )
                        "
                      />
                    } @else {
                      @if (capabilityItem.contextualParameterNames.length > 0) {
                        <ai-contextual-parameters
                          class="no-hover-area"
                          [parameterNames]="capabilityItem.contextualParameterNames"
                          (click)="$event.stopPropagation()"
                        />
                      }
                      <ai-capability-configuration
                        class="no-hover-area"
                        [capabilityForm]="capability"
                        [excludeVariables]="capabilityItem.contextualParameterNames"
                        (click)="$event.stopPropagation()"
                      />
                    }
                  </div>
                  <div class="capability-actions">
                    @if (capability.invalid) {
                      <mat-icon class="invalid-icon" color="warn">error</mat-icon>
                    }
                    @if (capability.isOverride()) {
                      <button
                        mat-icon-button
                        class="menu-button"
                        title="{{ 'AI_ASSISTANT.SETTINGS.ROLLBACK' | translate }}"
                        (click)="handleRollbackClicked(capability, $event)"
                      >
                        <mat-icon>undo</mat-icon>
                      </button>
                    }
                    <button
                      mat-icon-button
                      [matMenuTriggerFor]="capabilityMenu"
                      class="menu-button"
                      (click)="$event.stopPropagation()"
                    >
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #capabilityMenu="matMenu">
                      <button mat-menu-item [disabled]="isMoveUpDisabled(i)" (click)="moveCapabilityUp(i)">
                        <span>{{ 'AI_ASSISTANT.SETTINGS.MOVE_UP' | translate }}</span>
                      </button>
                      <button mat-menu-item [disabled]="isMoveDownDisabled(i)" (click)="moveCapabilityDown(i)">
                        <span>{{ 'AI_ASSISTANT.SETTINGS.MOVE_DOWN' | translate }}</span>
                      </button>
                      <button mat-menu-item (click)="handleCapabilityRemoveClicked($event, i)">
                        <span>{{ 'AI_ASSISTANT.SETTINGS.REMOVE' | translate }}</span>
                      </button>
                    </mat-menu>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          }
        }
      </div>
    }
  </mat-card-content>
  <mat-card-footer class="card-footer">
    <button mat-stroked-button (click)="handleCapabilityAddClicked()">
      <mat-icon>add</mat-icon>
      {{ 'AI_ASSISTANT.SETTINGS.ADD_CAPABILITY' | translate }}
    </button>
  </mat-card-footer>
</mat-card>
